<template>
  <div class="progress-circle-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: "ProgressCircleList",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/progress-circle-list";
</style>